import React from "react";
import ArticlesItem from "./ArticlesItem";

export default function ArticlesItemList({ articles, changeStatus, tagToSearch }) {
  return (
    <div className="articles-item-list">
      <div className="admin-article-bar">
        <p className="admin-article-item-title">TÍTULO</p>
        <p className="admin-article-item-category">CATEGORÍA</p>

        <p className="admin-article-item-position">POSICIÓN</p>
        <p className="admin-article-item-nameydate">AUTOR</p>
     
        <p className="admin-article-item-tags"> TAGS</p>

        <div className="admin-article-item-button-row"></div>
      </div>
      {articles.sort((a, b) => b.created - a.created).map((article, index) => (
        <ArticlesItem key={index} {...article} changeStatus={changeStatus} tagToSearch={tagToSearch} />
      ))}
    </div>
  );
}
